// Petit magasin observable pour le HUD React, mis à jour ~10 fois par seconde (pas à chaque image).
import type { DeathInfo, SelfState, WorldInfo } from '../../../shared/protocol';
import type { NetStatus } from './net';

export interface Toast {
  id: number;
  text: string;
  kind: 'kill' | 'level' | 'evo' | 'info';
  at: number;
}

export interface HudState {
  net: NetStatus;
  me: SelfState | null;
  death: DeathInfo | null;
  deathAt: number;
  top: [string, number, number, number][];
  rank: number;
  total: number;
  humans: number;
  bots: number;
  toasts: Toast[];
  ping: number;
  fps: number;
  autofire: boolean;
  touch: boolean;
  kbps: number;
  world: WorldInfo | null;
  worldAt: number;
  /** Alerte arrière et télémétrie (modifications de détection). */
  rearAlert: boolean;
  telemetry: number | null;
  /** Résultat de roulette à révéler (déjà enregistré par le serveur). */
  reveal: { result: string; detail: Record<string, unknown> } | null;
  /** Soldes du compte connecté (jetons), null pour un invité. */
  wallet: Record<string, number> | null;
  /** État du salon privé (hôte, code, joueurs). */
  lobby: Extract<import('../../../shared/protocol').ServerMsg, { t: 'lobby' }> | null;
  /** Équipe du joueur (résultats de match). */
  myTeam: number | null;
}

export function initialHud(): HudState {
  return {
    net: 'connecting',
    me: null,
    death: null,
    deathAt: 0,
    top: [],
    rank: 0,
    total: 0,
    humans: 0,
    bots: 0,
    toasts: [],
    ping: 0,
    fps: 0,
    autofire: false,
    touch: false,
    kbps: 0,
    world: null,
    worldAt: 0,
    rearAlert: false,
    telemetry: null,
    reveal: null,
    wallet: null,
    lobby: null,
    myTeam: null,
  };
}

export class Store<T> {
  private listeners = new Set<() => void>();
  constructor(private state: T) {}
  get = (): T => this.state;
  set(patch: Partial<T>): void {
    this.state = { ...this.state, ...patch };
    for (const l of this.listeners) l();
  }
  subscribe = (fn: () => void): (() => void) => {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  };
}
